import React from 'react';
import { X } from 'lucide-react';
import { cn } from '../index';
import { Button } from './Button';

export interface FilterBarProps {
  /** Search input node (rendered first, grows to fill space). */
  search?: React.ReactNode;
  /** Filter controls (selects, etc.). Given fixed widths on desktop. */
  children?: React.ReactNode;
  /** Show a "Clear" button pushed to the far end. */
  showClear?: boolean;
  onClear?: () => void;
  className?: string;
}

/**
 * Responsive filter row: search grows, filters sit at fixed widths on desktop
 * and stack in a compact grid on mobile. Prevents everything spanning 100%.
 */
export const FilterBar: React.FC<FilterBarProps> = ({
  search, children, showClear, onClear, className,
}) => (
  <div className={cn('flex flex-col gap-2.5 lg:flex-row lg:flex-wrap lg:items-center', className)}>
    {search && (
      <div className="w-full lg:w-72 lg:flex-shrink-0">{search}</div>
    )}
    {children && (
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:flex lg:flex-wrap lg:items-center">
        {children}
      </div>
    )}
    {showClear && (
      <Button variant="ghost" size="sm" onClick={onClear} className="lg:ml-auto justify-self-start">
        <X className="h-3.5 w-3.5" />
        Clear
      </Button>
    )}
  </div>
);
